module.exports = __webpack_public_path__ + "static/media/Footer2.734b4348.png";